import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { useLanguage } from './Contexts/LanguageContext';  // Correct import for the Context

// Import the flag images as modules, since they're inside the src folder
import nlFlag from './assets/icons/nlFlag.svg';
import ukFlag from './assets/icons/ukFlag.svg';

function Navbar() {
    const { toggleLanguage, language } = useLanguage();  // Get the current language and toggle function

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <h1 className="navbar-logo">CodeManifest</h1>
                <ul className="navbar-links">
                    <li><Link to="/" className="navbar-link">{language === 'nl' ? 'Home' : 'Home'}</Link></li>
                    <li><Link to="/about" className="navbar-link">{language === 'nl' ? 'Over Mij' : 'About Me'}</Link></li>
                    <li><Link to="/projects" className="navbar-link">{language === 'nl' ? 'Projecten' : 'Projects'}</Link></li>
                </ul>
                <div className="navbar-button-container">
                    {/* Replace the "Contact" link with a button, using Link to avoid page reload */}
                    <Link to="/contact">
                        <button className="navbar-button">
                            {language === 'nl' ? 'Contact' : 'Contact'}
                        </button>
                    </Link>
                </div>
                {/* Language toggle button with flag icons */}
                <button onClick={toggleLanguage} className="language-toggle-btn">
                    {language === 'nl' ? (
                        <img src={nlFlag} alt="Nederlands" style={{ width: '30px', height: 'auto' }} />
                    ) : (
                        <img src={ukFlag} alt="English" style={{ width: '30px', height: 'auto' }} />
                    )}
                </button>
            </div>
        </nav>
    );
}

export default Navbar;
